module.exports = __webpack_public_path__ + "img/gwrraSeal@1x.edca9390.png";